var map = {
	"./vc-za-btj/assets/background/background-image.webp": 43083,
	"./vc-za-chess-masters/assets/background/background-image.webp": 61769,
	"./vc-za-cricket-zone/assets/background/background-image.webp": 39825,
	"./vc-za-daily-five/assets/background/background-image.webp": 33877,
	"./vc-za-fantasy-dribble/assets/background/background-image.webp": 92780,
	"./vc-za-gamezar/assets/background/background-image.webp": 2218,
	"./vc-za-h2h/assets/background/background-image.webp": 54681,
	"./vc-za-motorsport-zone/assets/background/background-image.webp": 10085,
	"./vc-za-openly/assets/background/background-image.webp": 90176,
	"./vc-za-qi/assets/background/background-image.webp": 61335,
	"./vc-za-rugby-zone/assets/background/background-image.webp": 99749,
	"./vc-za-stc/assets/background/background-image.webp": 96371,
	"./vc-za-u3/assets/background/background-image.webp": 56565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39494;